import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  overallContainer: {
    position: 'relative',
    width: 'max-content',
  },
}));

export default useStyles;
